// @ts-nocheck
import { ForbiddenError, TrialEndedError } from '../api/apiUtils';

export function handleError(e, navigate, callback) {
  if (e instanceof TrialEndedError) {
    navigate('/trial-ended');
  } else if (e instanceof ForbiddenError) {
    navigate('/access-denied');
  } else if (e instanceof Error) {
    if (callback) {
      callback(e);
    } else {
      throw e;
    }
  }
}
